<script setup lang="ts">
import { cartBus } from '@/event/cartBus'
import { setRemoveProductMessage } from '@/happyTheme/event/modalBasket/messageAlertElementBasketHappy'
import { onMounted, ref } from 'vue'
import { Plus, Minus } from 'lucide-vue-next'

const props = defineProps<{ index: number }>()

const counterBasket = ref(0)

function increment() {
    counterBasket.value++
    if (counterBasket.value > 1) {
        const countElement = counterBasket.value - 1
        const price = cartBus.value[props.index].total_price / countElement
        const priceTax = cartBus.value[props.index].price_tax / countElement

        cartBus.value[props.index].quantity = counterBasket.value
        cartBus.value[props.index].total_price = price * counterBasket.value
        cartBus.value[props.index].price_tax = priceTax * counterBasket.value
    }
}

function decrement() {
    if (counterBasket.value > 1) {
        const countElement = counterBasket.value
        counterBasket.value--

        const price = cartBus.value[props.index].total_price / countElement
        const priceTax = cartBus.value[props.index].price_tax / countElement

        cartBus.value[props.index].quantity = counterBasket.value
        cartBus.value[props.index].total_price = price * counterBasket.value
        cartBus.value[props.index].price_tax = priceTax * counterBasket.value
    } else if (counterBasket.value === 1) {
        const product = cartBus.value[props.index]
        setRemoveProductMessage(product)
    }
}

onMounted(() => {
    if (cartBus.value) {
        counterBasket.value = cartBus.value[props.index].quantity ?? 0
    }
})
</script>

<template>
    <section class="section-button-select-basket-happy">
        <div class="min-w-5 min-h-5">
            <button
                class="button-minus-basket-happy"
                @click.stop="decrement()"
                v-if="counterBasket >= 1"
            >
                <Minus :size="12" :stroke-width="2" class="svg-minus-happy" />
            </button>
        </div>
        <p class="text-counter-option-value-happy">{{ counterBasket }}</p>

        <button class="button-plus-basket-happy" @click.stop="increment()">
            <Plus :size="12" :stroke-width="2" class="svg-plus-happy" />
        </button>
    </section>
</template>

<style scoped>
.section-button-select-basket-happy {
    @apply flex items-center justify-between gap-2 min-w-16 max-w-24 h-full;
}

.button-minus-basket-happy {
    /* refactored: per-theme border/bg -> accent */
    @apply flex items-center border rounded-[5px] p-1 shadow-sm bg-t-accent border-t-accent;
}

.svg-minus-happy {
    /* refactored: Lucide uses currentColor -> text-t-on-accent */
    @apply w-3 h-3 text-t-on-accent;
}

.text-counter-option-value-happy {
    /* refactored: per-theme text -> text-t-text */
    @apply text-lg text-center w-6 font-semibold text-t-text;
}

.button-plus-basket-happy {
    /* refactored: per-theme border/bg -> accent */
    @apply flex items-center border p-1 rounded-[5px] shadow-sm bg-t-accent border-t-accent;
}

.svg-plus-happy {
    /* refactored: Lucide uses currentColor -> text-t-on-accent */
    @apply w-3 h-3 text-t-on-accent;
}

.button-plus-basket-happy:active .svg-plus-happy,
.button-plus-basket-happy:focus .svg-plus-happy {
    /* refactored: Lucide uses currentColor -> text-t-on-accent */
    @apply text-t-on-accent;
}
.button-minus-basket-happy:active,
.button-plus-basket-happy:active,
.button-minus-basket-happy:focus,
.button-plus-basket-happy:focus {
    /* refactored: per-theme active -> accent-hover */
    @apply bg-t-accent-hover border-t-accent-hover;
}
.button-minus-basket-happy:active .svg-minus-happy,
.button-minus-basket-happy:focus .svg-minus-happy {
    @apply text-t-on-accent;
}
@media (hover: hover) {
    .button-plus-basket-happy:hover,
    .button-minus-basket-happy:hover {
        /* refactored: per-theme hover -> accent-hover */
        @apply bg-t-accent-hover border-t-accent-hover;
    }
    .button-plus-basket-happy:hover .svg-plus-happy {
        @apply text-t-on-accent;
    }
    .button-minus-basket-happy:hover .svg-minus-happy {
        @apply text-t-on-accent;
    }
}
</style>
